import { type AxiosInstance, create } from 'axios'

import { type PublicGlobalConfig } from '../../../global-config'
import {
  HTTP_HEADER_ACCEPT_LANGUAGE,
  HTTP_HEADER_CACHE_CONTROL,
} from '../../../http'

let clientSideGlooAxiosInstance: AxiosInstance | undefined

/**
 * Build axios instance for Gloo API clients, with default configs.
 * Instance supposed to be reused so do not put any "per request" logic in here.
 */
export const apiBuildGlooClientSideAxiosInstance = (
  publicGlobalConfig: PublicGlobalConfig,
): AxiosInstance => {
  clientSideGlooAxiosInstance ??= create({
    headers: {
      /**
       * Cache `axios` instance with current locale as it's not changing during user session.
       * Links to other languages are hard, no client navigation happens between site languages.
       */
      [HTTP_HEADER_ACCEPT_LANGUAGE]: publicGlobalConfig.locale,
      [HTTP_HEADER_CACHE_CONTROL]: 'no-cache',
    },
  })

  return clientSideGlooAxiosInstance
}
